var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Twitter_svg__a",
    x1: 0.935,
    x2: 0,
    y1: 0.966,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff2264"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb100"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18438"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.146 0h23.708A6.146 6.146 0 0 1 36 6.146v23.708A6.146 6.146 0 0 1 29.854 36H6.146A6.146 6.146 0 0 1 0 29.854V6.146A6.146 6.146 0 0 1 6.146 0",
    "data-name": "Path 32154",
    style: {
      fill: "url(#Twitter_svg__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 49.744a7.651 7.651 0 0 1-2.126.587 3.691 3.691 0 0 0 1.626-2.055 7.343 7.343 0 0 1-2.34.9 3.685 3.685 0 0 0-6.383 2.541 3.853 3.853 0 0 0 .085.848 10.421 10.421 0 0 1-7.606-3.888 3.735 3.735 0 0 0 1.134 4.967 3.624 3.624 0 0 1-1.67-.457v.041a3.727 3.727 0 0 0 2.956 3.652 3.658 3.658 0 0 1-.967.12 3.241 3.241 0 0 1-.7-.063 3.729 3.729 0 0 0 3.448 2.589 7.381 7.381 0 0 1-4.574 1.587A6.864 6.864 0 0 1 0 61.062a10.335 10.335 0 0 0 5.661 1.668 10.471 10.471 0 0 0 10.5-10.576c0-.164-.006-.323-.013-.48A7.391 7.391 0 0 0 18 49.744",
    style: {
      fill: "#fff"
    },
    transform: "translate(8.936 -38.365)"
  })));
};
export default SvgTwitter;